@if (inMenu()) {
  <button mat-menu-item (click)="onClickCopyLinkToClipboard()">
    <mat-icon>link</mat-icon>
    <span transloco="COPY_LINK_TO_CLIPBOARD"></span>
  </button>
} @else {
  <button
    mat-icon-button
    [matTooltip]="'COPY_LINK_TO_CLIPBOARD' | transloco"
    matTooltipShowDelay="1000"
    [matTooltipPosition]="matTooltipPosition"
    (click)="onClickCopyLinkToClipboard()"
  >
    <mat-icon>link</mat-icon>
  </button>
}
